
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactSelect from 'react-select'
import { Button, Card, Col, Label, Row } from 'reactstrap'
import Csv_Image from '../../../assets/images/csv-image.png'
import { getVendor_cats } from '../../../store/vendor_cat/actions'
const arr1 = [
    'capasity',
    'vendor type',
    'setting type',
    'package offered',
    'price usd',
    'exclusive vendor'
];
const arr2 = [
    'studio location',
    'location served',
    'specialization',
    'package offered',
    'price usd',
    'exclusive vendor',
    'availabel services',
    'pacage offered',
    'price range per package'
];
function VendorImportCSV() {
    const refFile = useRef()
    const dispatch = useDispatch()
    const [file, setFile] = useState({})
    const [vendorType, setvendorType] = useState([])

    const [arra, setArra] = useState([])

    useEffect(() => {
        dispatch(getVendor_cats({ is_active: 1 }))

    }, [])

    useEffect(() => {
        setArra(vendorType?.label ? vendorType?.label === 'venue' ? arr1 : arr2 : [])
    }, [vendorType])
    
    const vendor_cats = useSelector(
        state => state.vendors.vendor_cats.vendor_cats
    )
    const vendor_catsOptions = vendor_cats?.map(v => {
        return { label: v.cat_name_en, value: v.id }
    })
    const arr = vendorType?.label ? vendorType?.label === 'venue' ? arr1 : arr2 : []
    return (
        <>
            <div className="page-content">

                <div className="container-fluid">
                    <Col xl="6">
                        <Card>
                            <div className='m-3'>
                                <Label>Template</Label>
                                <Row>
                                    <Col xl="4">
                                        <div className="mb-3">

                                            <ReactSelect
                                                value={vendorType}
                                                onChange={(option, event) => {
                                                    setvendorType(option)
                                                }}
                                                options={vendor_catsOptions}
                                                classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>

                                    <Col xl='3'>
                                        <Button color='danger' onClick={() => refFile.current.click()}>Pick csv file</Button>

                                    </Col>
                                    {
                                        file?.name ? 
                                            <Col xl='2' >
                                                <Row>
                                                    <Col>
                                                        <img
                                                            className="avatar-sm"
                                                            src={Csv_Image}
                                                            alt=""
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <Label>{file?.name && file?.name}</Label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            :null
                                    }
                                   
                                </Row>
                                {
                                    file?.name ? arr?.map(a => (
                                        <Row className='mt-2'>
                                            <Col xl='6'>
                                                <Label>{a}</Label>
                                            </Col>
                                            <Col xl='6'>
                                                <ReactSelect
                                                    // value={arr.map(a=>({'label':a,'value':a}))}
                                                    onChange={(option, event) => {
                                                        setArra(arra.filter(a=>a!=option.label))
                                                    }}
                                                    options={arra.map(a => ({ 'label': a, 'value': a }))}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </Col>
                                        </Row>
                                    ))
                                        :null
                                }

                            </div>
                            <Col xl='12' >
                                <Button color='primary' style={{ float: 'right',margin:20 }}>Import</Button>
                            </Col>
                            
                        </Card>
                    </Col>

                </div>
                <input type='file' ref={refFile} onChange={(e) => console.log(setFile(e.target?.files[0]))} style={{ display: 'none' }} />
            </div>
        </>

    )
}

export default VendorImportCSV